import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {
  isInstructorAllowedAppPath,
  useCourseManagementAccess,
} from 'Screens/TrainingManagement/courseManagementShared';

type InstructorAccessGuardProps = {
  children: React.ReactNode;
  loadingFallback?: React.ReactNode;
};

const InstructorAccessGuard = ({children, loadingFallback = null}: InstructorAccessGuardProps) => {
  const {isInstructorOnly, loading} = useCourseManagementAccess();
  const location = useLocation();

  if (loading) {
    return <>{loadingFallback}</>;
  }

  if (isInstructorOnly && !isInstructorAllowedAppPath(location.pathname)) {
    return <Navigate to="/course-management" replace />;
  }

  return <>{children}</>;
};

export default InstructorAccessGuard;
